module.exports = __webpack_public_path__ + "img/form-template.a51c7c64.svg";